export default {
    header: {
        logout: 'Logout',
        profile: 'Profile',
        hotline: 'Hotline',
        language: 'Language'
    },
    footer: {},
    menu: {
        // Menu restructure 2026-07: sections (group headers) + merged groups
        sectionCommunication: 'Communication',
        sectionEducation: 'Students & Teaching',
        sectionServices: 'Services',
        sectionFinance: 'Finance',
        sectionOperations: 'Operations',
        sectionSystem: 'System',
        groupMyWork: 'My Work',
        groupUserPermission: 'Users & Permissions',
        groupSchoolData: 'School & Data',
        groupNotificationNews: 'Notifications & News',
        groupStudentParent: 'Students & Parents',
        groupTeaching: 'Teaching & Timetable',
        groupClb: 'Clubs',
        groupOtherServices: 'Other Services',
        groupMeal: 'Meals',
        groupTuition: 'Tuition & Fees',
        groupHrTimekeeping: 'HR & Timekeeping',
        groupStaff: 'HR',
        groupTimekeeping: 'Timekeeping',
        groupInventoryPurchase: 'Inventory & Procurement',
        notification: 'Notifications',
        news: 'News',
        email: 'Email',
        admissions: 'Admissions',
        bus: 'School Bus',
        latePickup: 'Late Pickup',
        nutrition: 'Nutrition',
        medical: 'Health',
        payment: 'Payments',
        assets: 'Assets',
        guest: 'Guest',
        profile: 'Profile',
        listBrandname: 'Brandname List',
        listPhoneNumber: 'Phone Number List',
        listRequest: 'Request List',
        createRequest: 'Create Request',
        logout: 'Logout',
        // Dashboard
        dashboard: 'Dashboard',
        // Account Management
        accountManagement: 'Account Management',
        // Notification
        notificationManagement: 'Notification Management',
        // News
        newsManagement: 'News Management',
        // Attendance
        attendance: 'Attendance',
        dailyAttendance: 'Daily Attendance',
        leaveRequest: 'Student Leave Request',
        mealAttendance: 'Meal Attendance',
        latePickupAttendance: 'Late Pickup Attendance',
        clbAttendance: 'Club Attendance',
        attendanceReport: 'Attendance Report',
        clbAttendanceReport: 'Club Attendance Report',
        mealReport: 'Meal Report',
        // Meal Management
        mealManagement: 'Meal Management',
        mealService: 'Meal Service Management',
        mealRegister: 'Meal Registration',
        // Parent Management
        parentManagement: 'Parent Management',
        parentList: 'Parent List',
        parentLink: 'Parent Linking',
        // SMS/Gmail
        smsManagement: 'SMS/Gmail Messages',
        sendExternalSms: 'External SMS Management',
        sendAdvertisingEmail: 'Advertising Email Management',
        // Admissions
        admissionsManagement: 'Admissions Management',
        statusNameManagement: 'Status Name Management',
        customerGroupManagement: 'Customer Group Management',
        enrollmentCampaign: 'Enrollment Campaign',
        customerList: 'Customer List',
        admissionsReport: 'Report',
        // Timekeeping Config
        timekeepingConfig: 'Timekeeping Configuration',
        config: 'Configuration',
        workShift: 'Work Shift',
        teachingAssignment: 'Teaching Assignment',
        supplementaryWork: 'Supplementary Work Management',
        eventAssignment: 'Event Assignment',
        attendanceZone: 'Attendance Zone Management',
        attendanceWifi: 'Attendance WiFi Management',
        timekeepingDevice: 'Timekeeping Device Management',
        // Timekeeping
        timekeeping: 'Timekeeping',
        leaveApplication: 'Leave Application',
        swapLesson: 'Lesson Swap Request',
        timekeepingList: 'Timekeeping',
        complaintApproval: 'Complaint Approval',
        staffTimekeepingView: 'Staff Timekeeping View',
        staffLessonView: 'Staff Lesson View',
        timekeepingReport: 'Timekeeping Report',
        lessonReport: 'Lesson Report',
        lessonComplaint: 'Lesson Complaint Management',
        // System
        system: 'System',
        schoolGroupManagement: 'School Group Management',
        schoolManagement: 'School Management',
        dataDeclaration: 'Data Declaration',
        schedule: 'Schedule',
        dataTransfer: 'Data Transfer',
        permissionManagement: 'Permission Management',
        permissionGroupManagement: 'Permission Group Management',
        userGroupPermission: 'User Group Permission',
        userManagement: 'User Management',
        versionManagement: 'Version Management',
        // Student
        studentManagement: 'Student Management',
        admissionsZoneDiscount: 'Admissions Zone Discount Config',
        admissionsRegisterDiscount: 'Admissions Registration Date Discount Config',
        specialDiscount: 'Special Discount Config',
        studentProfile: 'Student Profile',
        firstYearClassAssignment: 'First Year Class Assignment',
        gradeManagement: 'Grade Management',
        finalGradeReport: 'Final Grade Report',
        // Staff
        staffManagement: 'Staff Management',
        staffList: 'Staff Management',
        officerDocumentType: 'Staff Document Catalog',
        officerReport: 'HR Reports',
        // Fee
        feeManagement: 'Fee Management',
        feeItems: 'Fee Items',
        feeItemCollection: 'Fee Collection Management',
        tuitionConfig: 'Tuition Fee Config',
        tuitionReport: 'Tuition Collection Report',
        feeCollectionReport: 'Fee Collection Report',
        receiptManagement: 'Receipt Management',
        // Bus
        busManagement: 'Bus Management',
        busServiceType: 'Bus Service Type',
        busRoute: 'Bus Route',
        busRegister: 'Bus Registration',
        busRegisterRequest: 'Bus Registration Request',
        busAttendanceReport: 'Bus Attendance Report',
        // CLB
        clbManagement: 'Club Management',
        clbClass: 'Club Class Management',
        clbRegister: 'Club Registration Management',
        // Summer
        summerManagement: 'Summer Course Management',
        summerClass: 'Summer Class Management',
        summerRegister: 'Summer Registration Management',
        // Other Services
        otherServiceManagement: 'Other Service Management',
        productManagement: 'Product Management',
        serviceManagement: 'Service Management',
        serviceRegister: 'Service Registration Management',
        serviceApproval: 'Approve Service Register/Cancel Requests',
        // Late Pickup
        latePickupManagement: 'Late Pickup Management',
        latePickupConfig: 'Late Pickup Price Config',
        latePickupRegister: 'Late Pickup Registration',
        latePickupReport: 'Late Pickup Report',
        // Nutrition
        nutritionManagement: 'Nutrition Management',
        foodType: 'Food Type',
        foodGroup: 'Food Group',
        supplier: 'Supplier',
        food: 'Food',
        dish: 'Dish',
        menuManagement: 'Menu',
        weeklyMenu: 'Weekly Menu',
        dailyMenu: 'Daily Menu',
        // Medical
        medicalManagement: 'Medical Management',
        medicationManagement: 'Medication Management',
        // Log
        logManagement: 'Log Management'
    },
    common: {
        search: 'Search',
        add: 'Add New',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        confirm: 'Confirm',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit',
        reset: 'Reset',
        export: 'Export',
        import: 'Import',
        print: 'Print',
        view: 'View',
        detail: 'Detail',
        status: 'Status',
        action: 'Action',
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading...',
        noData: 'No Data',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        info: 'Information',
        total: 'Total',
        page: 'Page',
        rowsPerPage: 'Rows per page',
        of: 'of',
        home: 'Home',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        required: 'Required',
        optional: 'Optional',
        from: 'From',
        to: 'To',
        date: 'Date',
        time: 'Time',
        startDate: 'Start Date',
        endDate: 'End Date',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        createdBy: 'Created By',
        updatedBy: 'Updated By',
        name: 'Name',
        code: 'Code',
        description: 'Description',
        note: 'Note',
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        birthday: 'Birthday',
        year: 'Year',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        schoolYear: 'School Year',
        semester: 'Semester',
        class: 'Class',
        grade: 'Grade',
        student: 'Student',
        teacher: 'Teacher',
        parent: 'Parent',
        staff: 'Staff',
        school: 'School',
        department: 'Department',
        position: 'Position',
        subject: 'Subject',
        confirmDelete: 'Are you sure you want to delete?',
        confirmAction: 'Are you sure you want to perform this action?',
        deleteSuccess: 'Deleted successfully',
        saveSuccess: 'Saved successfully',
        updateSuccess: 'Updated successfully',
        createSuccess: 'Created successfully',
        operationFailed: 'Operation failed',
        networkError: 'Network connection error',
        sessionExpired: 'Session expired',
        permissionDenied: 'Permission denied',
        invalidData: 'Invalid data',
        fileNotFound: 'File not found',
        uploadSuccess: 'Upload successful',
        downloadSuccess: 'Download successful',
        pleaseSelect: 'Please select',
        pleaseEnter: 'Please enter',
        invalidFormat: 'Invalid format',
        maxLength: 'Maximum length',
        minLength: 'Minimum length'
    },
    auth: {
        login: 'Login',
        logout: 'Logout',
        username: 'Username',
        password: 'Password',
        rememberMe: 'Remember me',
        forgotPassword: 'Forgot password?',
        loginFailed: 'Incorrect username or password!',
        loginSuccess: 'Login successful',
        logoutSuccess: 'Logout successful',
        changePassword: 'Change Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password'
    }
}
